import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { ProductListSearch } from "src/sections/dashboard/software/product-list-search";
import { ProductListTable } from "src/sections/dashboard/software/product-list-table";
import { useGitHubStats } from "src/sections/dashboard/software/useGitHubStats";
import { useSoftwareSearch } from "../../../sections/dashboard/software/useSoftwareSearch";

const Page = () => {
  usePageView();
  const productsSearch = useSoftwareSearch();
  const {
    filteredStats: gitHubStats,
    loading: loading,
    count: count,
  } = useGitHubStats(productsSearch.state);

  return (
    <>
      <Seo title="Apps" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 4 }}>
            <Typography variant="h4" gutterBottom>
              Apps
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Open-source diabetes management applications available.
            </Typography>
          </Box>
          <Stack spacing={4}>
            {/* <Stack direction="row" justifyContent="space-between" spacing={4}>
              <Stack alignItems="center" direction="row" spacing={3}>
                <Button
                  component={RouterLink}
                  href={paths.dashboard.software.create}
                  startIcon={
                    <SvgIcon>
                      <PlusIcon />
                    </SvgIcon>
                  }
                  variant="contained"
                >
                  Add
                </Button>
              </Stack>
            </Stack> */}
            <Card>
              <ProductListSearch
                onFiltersChange={productsSearch.handleFiltersChange}
                filters={productsSearch.state.filters}
              />
              <ProductListTable
                onPageChange={productsSearch.handlePageChange}
                onRowsPerPageChange={productsSearch.handleRowsPerPageChange}
                page={productsSearch.state.page}
                items={gitHubStats}
                count={count}
                rowsPerPage={productsSearch.state.rowsPerPage}
                loading={loading}
              />
            </Card>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Page;
